import clsx from "clsx"
import styles from "./Checkbox.module.css"
import { IconColor, IconName, IconSize } from "@/app/components/icons/Icon"
import { Icon } from "@/app/components/icons/Icon"
import { useCallback, useEffect, useState } from "react"

export const Checkbox = ({
  checked = false,
  disabled = false,
  onChange,
}: {
  checked?: boolean
  disabled?: boolean
  onChange?: (checked: boolean) => void
}) => {
  const [isChecked, setIsChecked] = useState(checked)

  useEffect(() => {
    setIsChecked(checked)
  }, [checked])

  const onClick = useCallback(() => {
    if (disabled) return
    const previousChecked = isChecked
    const newChecked = !isChecked
    setIsChecked(newChecked)
    Promise.resolve(onChange?.(newChecked)).catch((error) => {
      console.error("Error changing checkbox state:", error)
      setIsChecked(previousChecked)
    })
  }, [disabled, onChange, isChecked])

  return (
    <div
      onClick={onClick}
      aria-checked={isChecked}
      className={clsx(
        styles.checkbox,
        isChecked ? styles.checked : styles.default,
        disabled && styles.disabled,
      )}
    >
      {isChecked && (
        <Icon
          name={IconName.Checkmark2}
          isFilled={true}
          color={IconColor.White}
          size={IconSize.xSmall}
        />
      )}
    </div>
  )
}
